import './AlertMessageWrapper.scss';

export function AlertMessageWrapper(id: string, content: JSX.Element | JSX.Element[]): JSX.Element {
  return (
    <div key={id} id={id} className="col-12 row w-100 ml-0 mr-0 pl-3 pr-3">
      {content}
    </div>
  );
}
